import { Injectable } from '@angular/core';
import { SessionStorageService } from 'angular-web-storage';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Token } from './shared/models/tokens';
import { LocalStorageKeys } from './shared/utils/local.storage.keys';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    public previousUrl: string = '';
    private currentUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private showBalance: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private newWalletBrazilian: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private tokens: BehaviorSubject<Array<Token>> = new BehaviorSubject<Array<Token>>([]);

    constructor(
        private readonly sessionStorage: SessionStorageService
    ) {
        const showBalance: boolean = this.sessionStorage.get(LocalStorageKeys.HIDE_BANKING_BALANCE);
        this.showBalance.next(showBalance);
    }

    public setCurrentUrl(url: string): void {
        this.previousUrl = this.currentUrl.getValue();
        this.currentUrl.next(url);
    }

    public getCurrentUrl(): Observable<string> {
        return this.currentUrl.asObservable();
    }

    public setNewWalletBrazilianSubscription(value: boolean): void {
        this.newWalletBrazilian.next(value);
    }

    public getNewWalletBrazilianSubscription(): Observable<boolean> {
        return this.newWalletBrazilian.asObservable();
    }

    /**
     * Set the list of tokens
     * @param tokens The list of tokens
     */
    public setTokens(tokens: Array<Token>): void {
        this.tokens.next(tokens);
    }

    /**
     * Get the list of tokens
     * @returns Array of the list of tokens
     */
    public getLastTokensList(): Array<Token> {
        return this.tokens.getValue();
    }


    /**
     * Returns the number pipe format, decimal places, and placeholder format for the token id.
     * Main fiat tokens use '1.2-2' pipe format, 2 decimal places, and placeholder format '0,00';
     * others use '1.6-6' pipe format, 6 decimal places, and placeholder format '0,000000'.
     * @param tokenId The token id
     * @returns Object with pipe format, decimal places, and placeholder format.
     * Example: { pipeFormat: '1.2-2', decimalPlaces: 2, placeHolderFormat: '0,00' }
     */
    public getTokenDecimalAndPipeFormat(tokenId?: string): { pipeFormat: string; decimalPlaces: number; placeHolderFormat: string } {
        const token = this.getLastTokensList()?.find(token => token.id === tokenId);
        const decimals = Number(token?.decimals_view_wallet);

        const pipeFormat = decimals ? `1.${decimals}-${decimals}` : '1.6-6';
        const decimalPlaces = decimals ? decimals : 6;
        const placeHolderFormat = decimalPlaces > 0 ? `0,${'0'.repeat(decimalPlaces)}` : '0';

        return { pipeFormat, decimalPlaces, placeHolderFormat };
    }

    public getPreviousUrl(): string {
        return this.previousUrl;
    }

    public getShowBalance(): Observable<boolean> {
        return this.showBalance.asObservable();
    }

    public toggleHideBalance(): void {
        const showBalance: boolean = this.showBalance.getValue();
        this.showBalance.next(!showBalance);
        this.sessionStorage.set(LocalStorageKeys.HIDE_BANKING_BALANCE, !showBalance);
    }
}
